// Component: CTAIconLink
// Author: reddyb
import * as React from 'react';
import CTAIconLinkNPM from '@component/CTAIconLink';
import { Text, Image } from '@sitecore-jss/sitecore-jss-react';
import { RoutableLink } from '../../react/RoutableLink';
import WBRString from '@component/WbrString';

const CTAIconLink = (props) => {
  const iconLinks = [];
  props.fields?.children?.map((link) => {
    iconLinks.push({
      isPriorityLink: link.fields?.priorityLink?.value,
      isDisabled: link.fields?.disabled?.value,
      link: (
        <RoutableLink field={link?.fields?.href} useATag={true}>
          <Image field={link.fields?.icon} editable={true} />
          <WBRString tag="span">
            <Text field={link.fields?.title} />
          </WBRString>
        </RoutableLink>
      ),
    });
  });

  return (
    <>
      <CTAIconLinkNPM
        heroText={<Text field={props.fields?.HeroTitle} />}
        heroDescriprtion={<Text field={props.fields?.HeroDescription} />}
        heroImage={<Image field={props.fields?.HeroImage} editable={true} />}
        iconLinks={iconLinks}
      />
    </>
  );
};
export default CTAIconLink;
